var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGym(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gym",
    transform: "translate(-419 -166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_home-trend-up",
    "data-name": "vuesax/linear/home-trend-up",
    transform: "translate(0 -22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-trend-up",
    transform: "translate(-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(428 188)",
    opacity: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2619",
    "data-name": "Group 2619",
    transform: "translate(30.617 166.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4396",
    "data-name": "Rectangle 4396",
    width: 6.636,
    height: 14.424,
    rx: 3.318,
    transform: "translate(388.383 13.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2591",
    "data-name": "Group 2591",
    transform: "translate(396.784 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4397",
    "data-name": "Rectangle 4397",
    width: 6.636,
    height: 14.424,
    rx: 3.318,
    transform: "translate(0.707 4.693) rotate(-45)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    y1: 7,
    x2: 7,
    transform: "translate(0.1 8.499)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17106",
    "data-name": "Rectangle 17106",
    width: 6.636,
    height: 14.424,
    rx: 3.318,
    transform: "translate(0.707 4.693) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17109",
    "data-name": "Rectangle 17109",
    width: 0.636,
    height: 6.424,
    rx: 0.318,
    transform: "translate(9.243 1.814) rotate(-45)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17110",
    "data-name": "Rectangle 17110",
    width: 0.636,
    height: 6.424,
    rx: 0.318,
    transform: "translate(389.746 18.093) rotate(-45)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17105",
    "data-name": "Rectangle 17105",
    width: 2,
    height: 9,
    transform: "translate(433.475 174.111) rotate(45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/Gym.72d4f06c3277d9aa6e4df1e9d8a2cbd9.svg";
export { ForwardRef as ReactComponent };